module.exports = __webpack_public_path__ + "img/tou.bfffde96.png";